export namespace ColorPicker {
    export function darker(rgb: string) {
        const rgbDecoded = rgb.trim().toLowerCase().replace('rgb', '').replace('(', '').replace(')', '').split(',');
        const result = `rgb(${Number(rgbDecoded[0].trim()) - 35}, ${Number(rgbDecoded[1].trim()) - 70}, ${Number(rgbDecoded[2].trim()) - 70})`;
        return result;
    }

    export function lighter(rgb: string) {
        const rgbDecoded = rgb.trim().toLowerCase().replace('rgb', '').replace('(', '').replace(')', '').split(',');
        const result = `rgb(${Number(rgbDecoded[0].trim()) + 0}, ${Number(rgbDecoded[1].trim()) + 45}, ${Number(rgbDecoded[2].trim()) + 45})`;
        return result;
    }

    export function hover(rgb: string) {
        const rgbDecoded = rgb.trim().toLowerCase().replace('rgb', '').replace('(', '').replace(')', '').split(',');
        const result = `rgb(${Number(rgbDecoded[0].trim()) + 25}, ${Number(rgbDecoded[1].trim()) + 10}, ${Number(rgbDecoded[2].trim()) + 35})`;
        return result;
    }

    export function mixOne(rgb: string) {
        const rgbDecoded = rgb.trim().toLowerCase().replace('rgb', '').replace('(', '').replace(')', '').split(',');
        const result = `rgb(${Number(rgbDecoded[0].trim()) - 5}, ${Number(rgbDecoded[1].trim()) - 5}, ${Number(rgbDecoded[2].trim()) - 5})`;
        return result;
    }
}
